export * from './customer/default/sidenav.constants';

export * from './customer/default/sidenav.path.constants';

export { SIDENAV_WIDTH as WIDTH, SIDENAV_EXPANDED_WIDTH as EXPANDED_WIDTH } from '@bedrock-rdk/constants';

export const animationDurationInSeconds = 0.3;

export const animationConfig = {
  duration: 0.3,
};

export default {
  animationDurationInSeconds,
  animationConfig,
};
